module.exports = __webpack_public_path__ + "static/media/Coretta.2a9c7757.png";